import axios from 'axios';

export const getMoteStates = () => {
  return axios.get('/api/moteStates');
};

export const postPortData = (params) => {
  return axios.post('/api/test/port-data', params);
};

/**
 * 针对nssy平台推送到管理处
 */
export const pushNsbd = (params) => {
  return axios.post('/api/push-nsbd', params);
};


export const getHeartBeats = (params) => {
  return axios.get('/api/test/heart-beats', params);
};

export const deleteHeartBeat = (register) => {
  return axios.delete(`/api/test/heart-beats/${register}`);
};

export const getGlodonPushConfig = () => {
  return axios.get('/glodon/config');
};

export const getOperationLogs = (params) => {
  return axios.get('/api/operation-logs', { params });
};
